// extracted by css-extract-rspack-plugin
module.exports =  {"faq":"FAQ-g_bk__faq","faq--inline":"FAQ-Nou8__faq--inline"};